import { KeyValue } from "@angular/common";
import { UdeuStatus } from "./udeu-status";
import { UdeuCreateFile, UdeuFile } from "./udeu-files";

export class UdeuCreateTransfer {
    data: UdeuTransfer;
    files: UdeuCreateFile[];
}

export class UdeuTransfer {
    id: string;
    name: string;
    status: UdeuStatus;
    data: UdeuData;
    documents: UdeuDocument[];
    files: UdeuFile[];
}

export class UdeuData {
    support: string | KeyValue<string, string>;
    course: string;
    unit: string;
    boxes: string;
    responsible: string;
    inCharge: string;
    phone: string;
    order: string | KeyValue<string, string>;
    startDate: string;
    endDate: string;
}

export class UdeuDocument {
    order: string;
    directory: string;
    title: string;
    content: string;
    date: string;
    code: string;
    signatura: string;
}